// App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DomainDetailPage from './pages/DomainDetailPage';
import Home from './pages';
import NotFoundPage from './pages/NotFound';
import AuctionContext from './context/AuctionContext';
import AddAuction from './pages/AddAuction';
import PasswordCheck from './componets/PasswordCheck';
import ProtectedRoute from './pages/ProtectedRoute';
import History01 from './pages/History01';
import OldArchive from './pages/OldArchive';

function App() {
 const [selectedAuction, setSelectedAuction] = useState(null);

 return (
    <AuctionContext.Provider value={{ selectedAuction, setSelectedAuction }}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/domain/:domainName" element={<DomainDetailPage />} />
          <Route path="/add-auction" element={<ProtectedRoute />} />
          <Route path="/hist01" element={<History01 />} />
          <Route path="/oldarchive" element={<OldArchive />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </AuctionContext.Provider>
 );
}

export default App;